// Transparencia · Integration Status widget — GL/ES
import i18n from "@/i18n";

const GL = {
  transparencia_integracion: {
    kicker: "TRANSPARENCIA RADICAL",
    title: "Estado da integración de datos",
    principle:
      "Compromiso NextGen/PRTR: mostramos en tempo real que datos temos, cales están bloqueados e por que.",
    // Summary tiles
    tile_esg_active: "KPIs ESG activos",
    tile_esg_provisional: "KPIs ESG estimación",
    tile_integrations_healthy: "Integracións saudables",
    tile_blockers: "Bloqueos activos",
    of: "de",
    // Integrations table
    integrations_title: "Integracións",
    th_integration: "Integración",
    th_provider: "Provedor",
    th_status: "Estado",
    th_endpoints: "Endpoints",
    th_last_check: "Última verificación",
    th_notes: "Notas",
    status_healthy: "Saudable",
    status_degraded: "Degradada",
    status_down: "Caída",
    status_unknown: "Sen supervisión",
    // Blockers table
    blockers_title: "Bloqueos activos",
    blockers_empty: "Sen bloqueos activos.",
    blocker_provider: "Provedor",
    blocker_traceid: "Trace ID",
    blocker_traceid_copy: "Dobre clic para copiar",
    blocker_detected: "Detectado",
    blocker_impact: "Impacto",
    blocker_status: "Estado",
    // ESG grid
    esg_title: "Estado dos 8 indicadores ESG",
    esg_active_badge: "Activo",
    esg_blocked_badge: "Bloqueado",
    esg_provisional_badge: "Provisional",
    // Footer
    footer_api: "Consultar API pública de datos abertos",
    footer_updated: "Última actualización",
    // Blocker statuses
    blocker_status_escalado_provedor: "Escalado ao provedor",
    blocker_status_pendente_administracion: "Pendente administración",
    blocker_status_abierto: "Aberto",
  },
};

const ES = {
  transparencia_integracion: {
    kicker: "TRANSPARENCIA RADICAL",
    title: "Estado de la integración de datos",
    principle:
      "Compromiso NextGen/PRTR: mostramos en tiempo real qué datos tenemos, cuáles están bloqueados y por qué.",
    tile_esg_active: "KPIs ESG activos",
    tile_esg_provisional: "KPIs ESG estimación",
    tile_integrations_healthy: "Integraciones saludables",
    tile_blockers: "Bloqueos activos",
    of: "de",
    integrations_title: "Integraciones",
    th_integration: "Integración",
    th_provider: "Proveedor",
    th_status: "Estado",
    th_endpoints: "Endpoints",
    th_last_check: "Última verificación",
    th_notes: "Notas",
    status_healthy: "Saludable",
    status_degraded: "Degradada",
    status_down: "Caída",
    status_unknown: "Sin supervisión",
    blockers_title: "Bloqueos activos",
    blockers_empty: "Sin bloqueos activos.",
    blocker_provider: "Proveedor",
    blocker_traceid: "Trace ID",
    blocker_traceid_copy: "Doble clic para copiar",
    blocker_detected: "Detectado",
    blocker_impact: "Impacto",
    blocker_status: "Estado",
    esg_title: "Estado de los 8 indicadores ESG",
    esg_active_badge: "Activo",
    esg_blocked_badge: "Bloqueado",
    esg_provisional_badge: "Provisional",
    footer_api: "Consultar API pública de datos abiertos",
    footer_updated: "Última actualización",
    blocker_status_escalado_provedor: "Escalado al proveedor",
    blocker_status_pendente_administracion: "Pendiente administración",
    blocker_status_abierto: "Abierto",
  },
};

i18n.addResourceBundle("gl", "common", GL, true, true);
i18n.addResourceBundle("es", "common", ES, true, true);

export default {};
